module.exports = __webpack_public_path__ + "static/media/buy_finish_service_help_2.0cc37430.jpg";